import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ColDef } from 'ag-grid-community';
import { AppState } from 'src/app/app.state';
import { DADeliverableTemplateViewModel } from 'src/app/shared/models/autogenerated';
import { AdapCellClassRules } from 'src/app/shared/utils/ag-grid-utils';
import { nameof } from 'src/app/shared/utils/nameof';
import { selectDADeliverableTemplates } from '../../store/global-settings.selectors';
import { AgGridButtonRenderer } from 'src/app/shared/components/ag-grid-button-renderer/ag-grid-button-renderer.component';
import { AgGridButtonRendererActions, AgGridButtonRendererModel } from 'src/app/shared/models/ag-grid-button-renderer.model';
import { DeliverableTemplatesTableActionsRendererComponent } from '../deliverable-templates-table-actions-renderer/deliverable-templates-table-actions-renderer.component';
import { DeliverableTemplateGridCellActions } from '../../models/deliverable-template-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-deliverable-templates-table',
  templateUrl: './deliverable-templates-table.component.html',
  styleUrl: './deliverable-templates-table.component.scss'
})
export class DeliverableTemplatesTableComponent {
  
  constructor(private store: Store<AppState>) {
  }
  
  daDeliverableTemplates$ = this.store.select(
    selectDADeliverableTemplates
  );

  @Output() editDADeliverableTemplate = new EventEmitter<string>();
  @Output() deleteDADeliverableTemplate = new EventEmitter<string>();

  configStoreTableName: string = 'DADeliverablesTemplates';

  components = {};

  defaultColDef: ColDef = {
      sortable: true,
      filter: true,
      filterParams: {
        newRowsAction: 'keep',
      },
      resizable: true,
      cellClassRules: AdapCellClassRules,
    };

  columnDefs: ColDef[] = [
    {
      field: nameof<DADeliverableTemplateViewModel>('title'),
      headerName: 'title',
      maxWidth: 500,
      width: 450,
      cellRenderer: AgGridButtonRenderer,
            cellRendererParams: {
              onInit: (
                actions: AgGridButtonRendererActions,
                data: DADeliverableTemplateViewModel
              ) => {
                actions.setProps({
                  text: data.title ?? '',
                  style: 'blank',
                  action: (data: DADeliverableTemplateViewModel) => {
                    this.editDADeliverableTemplate.emit(data.id);
                  },
                });
              },
            } as AgGridButtonRendererModel,
    },
    {
      field: nameof<DADeliverableTemplateViewModel>('onshore'),
      headerName: 'onshore',
      maxWidth: 120,
    },
    {
      field: nameof<DADeliverableTemplateViewModel>('offshore'),
      headerName: 'offshore',
      maxWidth: 120,
    },
    {
      field: nameof<DADeliverableTemplateViewModel>('deliverableDiscipline'),
      headerName: 'discipline',
      maxWidth: 120,
    },
    {
      field: nameof<DADeliverableTemplateViewModel>('docType'),
      headerName: 'type',
      maxWidth: 100,
    },
    {
      field: nameof<DADeliverableTemplateViewModel>('definition'),
      headerName: 'detail',
      maxWidth: 150,
    },
    {
      field: nameof<DADeliverableTemplateViewModel>('daDeliverablePhaseGuidelines'),
      headerName: 'phase guidelines',
      cellRenderer: (params : any) => {
        return params.value ? params.value.map((item: any) => item.projectPhaseTemplate.phaseId).join(', ') : '';
      },
      maxWidth: 150,
    },
    {
      maxWidth: 60,
      sortable: false,
      filter: false,
      resizable: false,
      cellRenderer: DeliverableTemplatesTableActionsRendererComponent,
      cellRendererParams: {
        onDeleteClick: (daDeliverableTemplateId: string) =>
          this.deleteDADeliverableTemplate.emit(daDeliverableTemplateId),
      } as DeliverableTemplateGridCellActions,
      pinned: 'right',
    },
  
  ];
}
